export enum TelemetrySdkEventGroup {
    Default = "default"
}
